import { WorkModel } from '@Entities/work/work'
import { AlternativeTitleModel } from '@Entities/work/alternative-title-model'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import { WriterModel } from '@Entities/work/writer-model'
import { RecordingModel } from '@Entities/work/recording-model'

export const getLatestUpdateDate = (work: WorkModel) => {
    let timeStamps: number[] = []
    const entities = [
        work,
        ...work.alternativeTitles,
        ...work.writers,
        ...work.recordings,
        ...work.originalPublishers,
        ...work.originalPublishers.flatMap((op) => op.administratorPublishers),
    ]
    entities.forEach((entity: WorkSubEntity) => {
        timeStamps = addDatesToArray(entity, timeStamps)
    })
    if (timeStamps.length >= 1) {
        return new Date(Math.max(...timeStamps))
    }
    return null
}

// This is necessary because Math.max cannot take Maybe<number>, so we have to guarantee it exists.
const addDatesToArray = (entity: WorkSubEntity, dates: number[]): number[] => {
    if (entity.lastUpdated && entity.lastUpdated !== '') {
        const time = new Date(entity.lastUpdated).getTime()
        dates.push(time)
        return dates
    }
    return dates
}

type WorkSubEntity =
    AlternativeTitleModel | WriterModel | RecordingModel | OriginalPublisherModel | PublisherModel | WorkModel
